import JS from '../assets/certificate/JS.png';
import DA from '../assets/certificate/DA.png';
import ML from '../assets/certificate/ML.png';

export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Google Advanced Data Analytics Certification ',
            details : 'Completed the Google Advanced Data Analytics certification, gaining hands-on experience in data preprocessing, visualization, and deriving actionable insights from complex datasets.',
            date : 'Jan 15, 2024',
            field : '',
            image : DA
        },
        {
            id : 2,
            title : 'JavaScript Certification',
            details : 'Acquired in-depth knowledge of JavaScript fundamentals, DOM manipulation, and modern ES6+ features, enabling the development of dynamic and responsive web applications.',
            date : 'June 22, 2024',
            field : '',
            image : JS
        },
        {
            id : 3,
            title : 'Machine Learning Certification',
            details : 'Learned key machine learning concepts, including supervised and unsupervised algorithms, model evaluation, and practical implementation using Python libraries like Scikit-learn and Pandas.',
            date : 'July 23, 2024',
            field : '',
            image : ML
        }

    ]
}


